import React from 'react';
import { Link } from 'react-router-dom';


const deeporbUrl = new URL('../assets/deeporb_big_2.png', import.meta.url).href;

const Hero = () => {
  return (
    <section className="bg-gray-900 text-white p-6">
      <div className="mx-auto max-w-screen-xl px-4 flex flex-col lg:flex-row items-center lg:items-start">

        {/* Image Section */}
        <div className="items-center justify-center text-center flex mb-8 lg:mb-0 lg:w-1/3">
          <img
            src={deeporbUrl}
            alt="Deeporb Illustration"
            className="w-full h-auto max-h-[400px] max-w-[400px]"
          />
        </div>

        {/* Text Content and CTA Section */}
        <div className="mx-auto max-w-3xl text-center lg:mx-0 lg:text-left p-10">
          <h1 className="bg-gradient-to-r from-green-300 via-blue-500 to-purple-600 bg-clip-text text-3xl font-extrabold text-transparent sm:text-5xl pb-1">
            DeepOrb Labs is an innovation studio for what's next in Cloud Automation, DeFi and AI agents.
          </h1>

          <p className="mx-auto mt-4 max-w-xl sm:text-xl/relaxed lg:mx-0 text-white">
            <strong>We know how to take the risk out of innovation.</strong> With deep experience scaling AI, blockchain, and cloud solutions from concept to production, we help forward-thinking companies confidently adopt emerging technologies and turn bold ideas into deployed systems that drive real business value.
          </p>

          <div className="mt-8 flex flex-wrap justify-center gap-4 lg:justify-start">
            {/* <Link
              className="block w-full rounded border border-blue-600 bg-blue-600 px-12 py-3 text-sm font-medium text-white hover:bg-transparent hover:text-white focus:outline-none focus:ring active:text-opacity-75 sm:w-auto"
              to="/metrics"
            >
              Available Metrics
            </Link>
            <Link
              className="block w-full rounded border border-blue-600 bg-blue-600 px-12 py-3 text-sm font-medium text-white hover:bg-transparent hover:text-white focus:outline-none focus:ring active:text-opacity-75 sm:w-auto"
              to="/metrics"
            >
              Subscription Plans
            </Link> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;